import React from "react";
import { Loader2 } from "lucide-react";

import styles from "./style.module.css";

const Loading = () => {
  return (
    <div className={styles.loading}>
      <Loader2 />
    </div>
  );
};

export default Loading;
